(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('EditProfileController', EditProfileController);

  /* ngInject */
  function EditProfileController($state, $stateParams, Flash, sessionService, smcProfileService) {
    const vm = this;

    vm.deleteProfile = deleteProfile;
    vm.id = $stateParams.id;
    vm.profile = {};
    vm.shareProfile = shareProfile;
    vm.unshareProfile = unshareProfile;
    vm.updateProfile = updateProfile;

    activate();

    function activate() {
      getProfile();
    }

    function deleteProfile() {
      smcProfileService(sessionService.getAuthToken()).destroy({ id: vm.id }, _ => {
        $state.go('application.social_media_compliance.profiles');
        Flash.create('success', 'Profile successfully deleted.');
        angular.element('#deleteProfileModal').modal('hide');
      });
    }

    function getProfile() {
      smcProfileService(sessionService.getAuthToken()).get({ id: vm.id }, response => vm.profile = response);
    }

    function shareProfile() {
      smcProfileService(sessionService.getAuthToken()).share({ id: vm.id }, _ => {
        $state.go('application.social_media_compliance.profiles');
        Flash.create('success', 'Profile successfully shared with organization.');
      });
    }

    function unshareProfile() {
      smcProfileService(sessionService.getAuthToken()).unshare({ id: vm.id }, _ => {
        $state.go('application.social_media_compliance.profiles');
        Flash.create('success', 'Profile successfully unshared with organization.');
      });
    }

    function updateProfile() {
      smcProfileService(sessionService.getAuthToken()).update({ id: vm.id }, vm.profile, _ => {
        $state.go('application.social_media_compliance.profiles');
        Flash.create('success', 'Profile successfully updated.');
      });
    }
  }
})();
